import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AppState } from '../../app.service';
import { ReactiveFormsModule } from '@angular/forms';
import { SubscriptionsService } from '../../../services/subscriptions.service';
import { SHOPIFY_TOKENS } from '../../../environments/environment';

@Component({
  selector: 'app-payments-modal',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
  templateUrl: './payments-modal.component.html',
  styleUrl: './payments-modal.component.scss'
})
export class PaymentsModalComponent implements OnInit, OnDestroy {
  private dialog = inject(MatDialogRef<any>);
  private appState = inject(AppState);
  private subscriptionsService = inject(SubscriptionsService);

  public data = inject(MAT_DIALOG_DATA);
  public paymentMethods;
  public paymentsLoaded = false;
  public selectedMethod;
  public displayRequiredMsg = false;
  public SHOPIFY_TOKENS = SHOPIFY_TOKENS;

  ngOnInit(): void {

    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
    this.appState.loading = true;
    this.subscriptionsService.getUserPayments().then((data) => {
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      const currentYear = now.getFullYear();
      this.paymentMethods = (data?.paymentMethods?.map(method => {
        const card = method?.instrument;
        //Skip if already revoked
        if (method?.revokedAt !== null) { method.expired = true; return method; }

        // Check Expiry date of the card
        if (card?.expiryYear > currentYear) { method.expired = false; return method; }
        if (card?.expiryYear === currentYear && card?.expiryMonth >= currentMonth) {
          method.expired = false; return method;
        };
        if (card?.expiryYear === currentYear && card?.expiryMonth < currentMonth) {
          method.expired = true; return method;
        };
        method.expired = false;
        return method;
      }) || [])
      // .filter(
      //   (method) => method?.id !== this.data?.paymentMethodId
      // );
    }).finally(() => {
      this.appState.loading = false;
      this.paymentsLoaded = true;
    })
  }
  goToShopify(): void {
    this.appState.loading = true;
    window.location.href = `https://${SHOPIFY_TOKENS.domain}/account`;
  }
  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }

  done(): void {
    if (this.selectedMethod) {
      this.displayRequiredMsg = false;
      this.closeDialog(this.selectedMethod)
    } else {
      this.displayRequiredMsg = true;
    }
  }

  selectCard(method) {
    this.selectedMethod = method;
    this.displayRequiredMsg = false;
  }
  cancel(): void {
    this.closeDialog();
  }
}
